import React, { useState, useContext } from 'react';
import "./Profile.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import AuthContext from "../../contexts/AuthProvider";
import { API_URL } from "../../utils/config";
const baseUrl = API_URL;
const Password = () => {
  const { t } = useTranslation("profile");
  const [currPassword, setCurrPassword] = useState("");
  const [currentVisible, setCurrentVisible] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newVisible, setNewVisible] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [Errors, setErrors] = useState(null);
  const navigate = useNavigate();
const { isAuthenticated } = useContext(AuthContext);
   const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
  const isValid = () =>
    currPassword !== "" &&
    currPassword !== newPassword &&
    newPassword.length >= 8 &&
    newPassword === confirmPassword &&
    checkStrength(newPassword) === "#198754";

  const Save = async () => {
    const loadingToast = toast.loading(t('password.toasts.processing'));
    if (currPassword === newPassword) {
      toast.update(loadingToast, {
        render: t('password.toasts.errorSame'),
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    } else if (newPassword !== confirmPassword) {
      toast.update(loadingToast, {
        render: t('password.toasts.errorMismatch'),
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    } else if (newPassword.length < 8) {
      toast.update(loadingToast, {
        render: t('password.toasts.errorShort'),
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    } else if (checkStrength(newPassword) !== "#198754") {
      toast.update(loadingToast, {
        render: t('password.toasts.errorWeak'),
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
    if (!isValid()) return;
    try {
      if (!isAuthenticated) {
        throw new Error(t('password.toasts.error', { message: 'No authentication token found' }));
      }

      const response = await fetch(`${baseUrl}/api/v1/attnd-venue/auth/change-password`, {
        method: 'POST',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json',
          lang: getLangFromLocalStorage(),
        },
        body: JSON.stringify({
          currentPassword: currPassword,
          newPassword: newPassword,
          passwordConfirm: confirmPassword,
        }),
      });

      if (!response.ok) {
        if (response.status === 401) {
          navigate('/login');
          throw new Error('Unauthorized');
        }
        const error = await response.json();
        setErrors(error);
        const errorMessage =
          error.error ||
          error.errors?.[0]?.currentPassword ||
          error.errors?.[0]?.newPassword ||
          error.errors?.[0]?.passwordConfirm ||
          "An unknown error occurred.";
        throw new Error(errorMessage);
      }

      toast.update(loadingToast, {
        render: t('password.toasts.success'),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setCurrPassword("");
      setNewPassword("");
      setNewVisible(false);
      setConfirmPassword("");
      setConfirmVisible(false);
    } catch (error) {
      console.error(error);
      toast.update(loadingToast, {
        render: t('password.toasts.error', { message: error.message }),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const checkStrength = (pwd) => {
    let score = -1;
    if (pwd.length >= 8) score++;
    if (/[A-Z]/.test(pwd)) score++;
    if (/[a-z]/.test(pwd)) score++;
    if (/[0-9]/.test(pwd)) score++;
    if (/[\W_]/.test(pwd)) score++;
    const strengthLevels = ["#DC3545", "#DC3545", "#FFC107", "#FFC107", "#198754"];
    return strengthLevels[score] || "#DC3545";
  };

  return (
    <div className="PasswordPage">
      <div className="Content">
        {/* Current Password */}
        <div className="Password">
          <div className="Input">
            <p>{t('password.currentPassword')}</p>
            <div
              className="password-input-container"
              style={Errors?.errors?.[0]?.currentPassword ? { border: "1px solid red" } : {}}
            >
              <input
                type={currentVisible ? "text" : "password"}
                value={currPassword}
                onChange={(e) => setCurrPassword(e.target.value)}
              />
              <span className="eye-icon" onClick={() => setCurrentVisible((vis) => !vis)}>
                {currentVisible ? (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="vuesax/outline/eye">
                      <g id="eye">
                        <path
                          id="Vector"
                          d="M12 16.3299C9.61004 16.3299 7.67004 14.3899 7.67004 11.9999C7.67004 9.60992 9.61004 7.66992 12 7.66992C14.39 7.66992 16.33 9.60992 16.33 11.9999C16.33 14.3899 14.39 16.3299 12 16.3299ZM12 9.16992C10.44 9.16992 9.17004 10.4399 9.17004 11.9999C9.17004 13.5599 10.44 14.8299 12 14.8299C13.56 14.8299 14.83 13.5599 14.83 11.9999C14.83 10.4399 13.56 9.16992 12 9.16992Z"
                          fill="#4D4D4D"
                        />
                        <path
                          id="Vector_2"
                          d="M12 21.02C8.23996 21.02 4.68996 18.82 2.24996 15C1.18996 13.35 1.18996 10.66 2.24996 8.99998C4.69996 5.17998 8.24996 2.97998 12 2.97998C15.75 2.97998 19.3 5.17998 21.74 8.99998C22.8 10.65 22.8 13.34 21.74 15C19.3 18.82 15.75 21.02 12 21.02ZM12 4.47998C8.76996 4.47998 5.67996 6.41998 3.51996 9.80998C2.76996 10.98 2.76996 13.02 3.51996 14.19C5.67996 17.58 8.76996 19.52 12 19.52C15.23 19.52 18.32 17.58 20.48 14.19C21.23 13.02 21.23 10.98 20.48 9.80998C18.32 6.41998 15.23 4.47998 12 4.47998Z"
                          fill="#4D4D4D"
                        />
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.47188 15.2799C9.28188 15.2799 9.09187 15.2099 8.94187 15.0599C8.12187 14.2399 7.67188 13.1499 7.67188 11.9999C7.67188 9.60992 9.61187 7.66992 12.0019 7.66992C13.1519 7.66992 14.2419 8.11992 15.0619 8.93992C15.2019 9.07992 15.2819 9.26992 15.2819 9.46992C15.2819 9.66992 15.2019 9.85992 15.0619 9.99992L10.0019 15.0599C9.85187 15.2099 9.66188 15.2799 9.47188 15.2799ZM12.0019 9.16992C10.4419 9.16992 9.17188 10.4399 9.17188 11.9999C9.17188 12.4999 9.30187 12.9799 9.54187 13.3999L13.4019 9.53992C12.9819 9.29992 12.5019 9.16992 12.0019 9.16992Z"
                      fill="#464646"
                    />
                    <path
                      d="M5.59984 18.51C5.42984 18.51 5.24984 18.45 5.10984 18.33C4.03984 17.42 3.07984 16.3 2.25984 15C1.19984 13.35 1.19984 10.66 2.25984 8.99998C4.69984 5.17998 8.24984 2.97998 11.9998 2.97998C14.1998 2.97998 16.3698 3.73998 18.2698 5.16998C18.5998 5.41998 18.6698 5.88998 18.4198 6.21998C18.1698 6.54998 17.6998 6.61998 17.3698 6.36998C15.7298 5.12998 13.8698 4.47998 11.9998 4.47998C8.76984 4.47998 5.67984 6.41998 3.51984 9.80998C2.76984 10.98 2.76984 13.02 3.51984 14.19C4.26984 15.36 5.12984 16.37 6.07984 17.19C6.38984 17.46 6.42984 17.93 6.15984 18.25C6.01984 18.42 5.80984 18.51 5.59984 18.51Z"
                      fill="#464646"
                    />
                    <path
                      d="M11.9986 21.02C10.6686 21.02 9.3686 20.75 8.1186 20.22C7.7386 20.06 7.5586 19.62 7.7186 19.24C7.8786 18.86 8.3186 18.68 8.6986 18.84C9.7586 19.29 10.8686 19.52 11.9886 19.52C15.2186 19.52 18.3086 17.58 20.4686 14.19C21.2186 13.02 21.2186 10.98 20.4686 9.81C20.1586 9.32 19.8186 8.85 19.4586 8.41C19.1986 8.09 19.2486 7.62 19.5686 7.35C19.8886 7.09 20.3586 7.13 20.6286 7.46C21.0186 7.94 21.3986 8.46 21.7386 9C22.7986 10.65 22.7986 13.34 21.7386 15C19.2986 18.82 15.7486 21.02 11.9986 21.02Z"
                      fill="#464646"
                    />
                    <path
                      d="M12.6915 16.2699C12.3415 16.2699 12.0215 16.0199 11.9515 15.6599C11.8715 15.2499 12.1415 14.8599 12.5515 14.7899C13.6515 14.5899 14.5715 13.6699 14.7715 12.5699C14.8515 12.1599 15.2415 11.8999 15.6515 11.9699C16.0615 12.0499 16.3315 12.4399 16.2515 12.8499C15.9315 14.5799 14.5515 15.9499 12.8315 16.2699C12.7815 16.2599 12.7415 16.2699 12.6915 16.2699Z"
                      fill="#464646"
                    />
                    <path
                      d="M2.00141 22.7502C1.81141 22.7502 1.62141 22.6802 1.47141 22.5302C1.18141 22.2402 1.18141 21.7602 1.47141 21.4702L8.94141 14.0002C9.23141 13.7102 9.71141 13.7102 10.0014 14.0002C10.2914 14.2902 10.2914 14.7702 10.0014 15.0602L2.53141 22.5302C2.38141 22.6802 2.19141 22.7502 2.00141 22.7502Z"
                      fill="#464646"
                    />
                    <path
                      d="M14.5287 10.2199C14.3387 10.2199 14.1488 10.1499 13.9988 9.99994C13.7088 9.70994 13.7088 9.22994 13.9988 8.93994L21.4687 1.46994C21.7587 1.17994 22.2388 1.17994 22.5288 1.46994C22.8188 1.75994 22.8188 2.23994 22.5288 2.52994L15.0588 9.99994C14.9088 10.1499 14.7187 10.2199 14.5287 10.2199Z"
                      fill="#464646"
                    />
                  </svg>
                )}
              </span>
            </div>
          </div>
          {/* strength indicators */}
          {/* <div className="Diff">
            {[2, 4, 6, 8].map((len) => (
              <svg
                key={len}
                width="159"
                height="6"
                viewBox="0 0 159 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="159"
                  height="6"
                  rx="3"
                  fill={currPassword.length >= len ? "#DC3545" : "#DBDBDB"}
                />
              </svg>
            ))}
          </div> */}
        </div>

        {/* New Password */}
        <div className="Password">
          <div className="Input">
            <p>{t('password.newPassword')}</p>
            <div
              className="password-input-container"
              style={Errors?.errors?.[0]?.newPassword ? { border: "1px solid red" } : {}}
            >
              <input
                type={newVisible ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <span className="eye-icon" onClick={() => setNewVisible((vis) => !vis)}>
                {newVisible ? (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="vuesax/outline/eye">
                      <g id="eye">
                        <path
                          id="Vector"
                          d="M12 16.3299C9.61004 16.3299 7.67004 14.3899 7.67004 11.9999C7.67004 9.60992 9.61004 7.66992 12 7.66992C14.39 7.66992 16.33 9.60992 16.33 11.9999C16.33 14.3899 14.39 16.3299 12 16.3299ZM12 9.16992C10.44 9.16992 9.17004 10.4399 9.17004 11.9999C9.17004 13.5599 10.44 14.8299 12 14.8299C13.56 14.8299 14.83 13.5599 14.83 11.9999C14.83 10.4399 13.56 9.16992 12 9.16992Z"
                          fill="#4D4D4D"
                        />
                        <path
                          id="Vector_2"
                          d="M12 21.02C8.23996 21.02 4.68996 18.82 2.24996 15C1.18996 13.35 1.18996 10.66 2.24996 8.99998C4.69996 5.17998 8.24996 2.97998 12 2.97998C15.75 2.97998 19.3 5.17998 21.74 8.99998C22.8 10.65 22.8 13.34 21.74 15C19.3 18.82 15.75 21.02 12 21.02ZM12 4.47998C8.76996 4.47998 5.67996 6.41998 3.51996 9.80998C2.76996 10.98 2.76996 13.02 3.51996 14.19C5.67996 17.58 8.76996 19.52 12 19.52C15.23 19.52 18.32 17.58 20.48 14.19C21.23 13.02 21.23 10.98 20.48 9.80998C18.32 6.41998 15.23 4.47998 12 4.47998Z"
                          fill="#4D4D4D"
                        />
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.47188 15.2799C9.28188 15.2799 9.09187 15.2099 8.94187 15.0599C8.12187 14.2399 7.67188 13.1499 7.67188 11.9999C7.67188 9.60992 9.61187 7.66992 12.0019 7.66992C13.1519 7.66992 14.2419 8.11992 15.0619 8.93992C15.2019 9.07992 15.2819 9.26992 15.2819 9.46992C15.2819 9.66992 15.2019 9.85992 15.0619 9.99992L10.0019 15.0599C9.85187 15.2099 9.66188 15.2799 9.47188 15.2799ZM12.0019 9.16992C10.4419 9.16992 9.17188 10.4399 9.17188 11.9999C9.17188 12.4999 9.30187 12.9799 9.54187 13.3999L13.4019 9.53992C12.9819 9.29992 12.5019 9.16992 12.0019 9.16992Z"
                      fill="#464646"
                    />
                    <path
                      d="M5.59984 18.51C5.42984 18.51 5.24984 18.45 5.10984 18.33C4.03984 17.42 3.07984 16.3 2.25984 15C1.19984 13.35 1.19984 10.66 2.25984 8.99998C4.69984 5.17998 8.24984 2.97998 11.9998 2.97998C14.1998 2.97998 16.3698 3.73998 18.2698 5.16998C18.5998 5.41998 18.6698 5.88998 18.4198 6.21998C18.1698 6.54998 17.6998 6.61998 17.3698 6.36998C15.7298 5.12998 13.8698 4.47998 11.9998 4.47998C8.76984 4.47998 5.67984 6.41998 3.51984 9.80998C2.76984 10.98 2.76984 13.02 3.51984 14.19C4.26984 15.36 5.12984 16.37 6.07984 17.19C6.38984 17.46 6.42984 17.93 6.15984 18.25C6.01984 18.42 5.80984 18.51 5.59984 18.51Z"
                      fill="#464646"
                    />
                    <path
                      d="M11.9986 21.02C10.6686 21.02 9.3686 20.75 8.1186 20.22C7.7386 20.06 7.5586 19.62 7.7186 19.24C7.8786 18.86 8.3186 18.68 8.6986 18.84C9.7586 19.29 10.8686 19.52 11.9886 19.52C15.2186 19.52 18.3086 17.58 20.4686 14.19C21.2186 13.02 21.2186 10.98 20.4686 9.81C20.1586 9.32 19.8186 8.85 19.4586 8.41C19.1986 8.09 19.2486 7.62 19.5686 7.35C19.8886 7.09 20.3586 7.13 20.6286 7.46C21.0186 7.94 21.3986 8.46 21.7386 9C22.7986 10.65 22.7986 13.34 21.7386 15C19.2986 18.82 15.7486 21.02 11.9986 21.02Z"
                      fill="#464646"
                    />
                    <path
                      d="M12.6915 16.2699C12.3415 16.2699 12.0215 16.0199 11.9515 15.6599C11.8715 15.2499 12.1415 14.8599 12.5515 14.7899C13.6515 14.5899 14.5715 13.6699 14.7715 12.5699C14.8515 12.1599 15.2415 11.8999 15.6515 11.9699C16.0615 12.0499 16.3315 12.4399 16.2515 12.8499C15.9315 14.5799 14.5515 15.9499 12.8315 16.2699C12.7815 16.2599 12.7415 16.2699 12.6915 16.2699Z"
                      fill="#464646"
                    />
                    <path
                      d="M2.00141 22.7502C1.81141 22.7502 1.62141 22.6802 1.47141 22.5302C1.18141 22.2402 1.18141 21.7602 1.47141 21.4702L8.94141 14.0002C9.23141 13.7102 9.71141 13.7102 10.0014 14.0002C10.2914 14.2902 10.2914 14.7702 10.0014 15.0602L2.53141 22.5302C2.38141 22.6802 2.19141 22.7502 2.00141 22.7502Z"
                      fill="#464646"
                    />
                    <path
                      d="M14.5287 10.2199C14.3387 10.2199 14.1488 10.1499 13.9988 9.99994C13.7088 9.70994 13.7088 9.22994 13.9988 8.93994L21.4687 1.46994C21.7587 1.17994 22.2388 1.17994 22.5288 1.46994C22.8188 1.75994 22.8188 2.23994 22.5288 2.52994L15.0588 9.99994C14.9088 10.1499 14.7187 10.2199 14.5287 10.2199Z"
                      fill="#464646"
                    />
                  </svg>
                )}
              </span>
            </div>
          </div>
          <div className="Diff">
            {[2, 4, 6, 8].map((len) => (
              <svg
                key={len}
                width="159"
                height="6"
                viewBox="0 0 159 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="159"
                  height="6"
                  rx="3"
                  fill={newPassword.length >= len ? checkStrength(newPassword) : "#DBDBDB"}
                />
              </svg>
            ))}
          </div>
        </div>

        {/* Confirm Password */}
        <div className="Password">
          <div className="Input">
            <p>{t('password.confirmPassword')}</p>
            <div
              className="password-input-container"
              style={Errors?.errors?.[0]?.passwordConfirm ? { border: "1px solid red" } : {}}
            >
              <input
                type={confirmVisible ? "text" : "password"}
                value={confirmPassword}
                onPaste={(e) => e.preventDefault()}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span className="eye-icon" onClick={() => setConfirmVisible((vis) => !vis)}>
                {confirmVisible ? (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="vuesax/outline/eye">
                      <g id="eye">
                        <path
                          id="Vector"
                          d="M12 16.3299C9.61004 16.3299 7.67004 14.3899 7.67004 11.9999C7.67004 9.60992 9.61004 7.66992 12 7.66992C14.39 7.66992 16.33 9.60992 16.33 11.9999C16.33 14.3899 14.39 16.3299 12 16.3299ZM12 9.16992C10.44 9.16992 9.17004 10.4399 9.17004 11.9999C9.17004 13.5599 10.44 14.8299 12 14.8299C13.56 14.8299 14.83 13.5599 14.83 11.9999C14.83 10.4399 13.56 9.16992 12 9.16992Z"
                          fill="#4D4D4D"
                        />
                        <path
                          id="Vector_2"
                          d="M12 21.02C8.23996 21.02 4.68996 18.82 2.24996 15C1.18996 13.35 1.18996 10.66 2.24996 8.99998C4.69996 5.17998 8.24996 2.97998 12 2.97998C15.75 2.97998 19.3 5.17998 21.74 8.99998C22.8 10.65 22.8 13.34 21.74 15C19.3 18.82 15.75 21.02 12 21.02ZM12 4.47998C8.76996 4.47998 5.67996 6.41998 3.51996 9.80998C2.76996 10.98 2.76996 13.02 3.51996 14.19C5.67996 17.58 8.76996 19.52 12 19.52C15.23 19.52 18.32 17.58 20.48 14.19C21.23 13.02 21.23 10.98 20.48 9.80998C18.32 6.41998 15.23 4.47998 12 4.47998Z"
                          fill="#4D4D4D"
                        />
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.47188 15.2799C9.28188 15.2799 9.09187 15.2099 8.94187 15.0599C8.12187 14.2399 7.67188 13.1499 7.67188 11.9999C7.67188 9.60992 9.61187 7.66992 12.0019 7.66992C13.1519 7.66992 14.2419 8.11992 15.0619 8.93992C15.2019 9.07992 15.2819 9.26992 15.2819 9.46992C15.2819 9.66992 15.2019 9.85992 15.0619 9.99992L10.0019 15.0599C9.85187 15.2099 9.66188 15.2799 9.47188 15.2799ZM12.0019 9.16992C10.4419 9.16992 9.17188 10.4399 9.17188 11.9999C9.17188 12.4999 9.30187 12.9799 9.54187 13.3999L13.4019 9.53992C12.9819 9.29992 12.5019 9.16992 12.0019 9.16992Z"
                      fill="#464646"
                    />
                    <path
                      d="M5.59984 18.51C5.42984 18.51 5.24984 18.45 5.10984 18.33C4.03984 17.42 3.07984 16.3 2.25984 15C1.19984 13.35 1.19984 10.66 2.25984 8.99998C4.69984 5.17998 8.24984 2.97998 11.9998 2.97998C14.1998 2.97998 16.3698 3.73998 18.2698 5.16998C18.5998 5.41998 18.6698 5.88998 18.4198 6.21998C18.1698 6.54998 17.6998 6.61998 17.3698 6.36998C15.7298 5.12998 13.8698 4.47998 11.9998 4.47998C8.76984 4.47998 5.67984 6.41998 3.51984 9.80998C2.76984 10.98 2.76984 13.02 3.51984 14.19C4.26984 15.36 5.12984 16.37 6.07984 17.19C6.38984 17.46 6.42984 17.93 6.15984 18.25C6.01984 18.42 5.80984 18.51 5.59984 18.51Z"
                      fill="#464646"
                    />
                    <path
                      d="M11.9986 21.02C10.6686 21.02 9.3686 20.75 8.1186 20.22C7.7386 20.06 7.5586 19.62 7.7186 19.24C7.8786 18.86 8.3186 18.68 8.6986 18.84C9.7586 19.29 10.8686 19.52 11.9886 19.52C15.2186 19.52 18.3086 17.58 20.4686 14.19C21.2186 13.02 21.2186 10.98 20.4686 9.81C20.1586 9.32 19.8186 8.85 19.4586 8.41C19.1986 8.09 19.2486 7.62 19.5686 7.35C19.8886 7.09 20.3586 7.13 20.6286 7.46C21.0186 7.94 21.3986 8.46 21.7386 9C22.7986 10.65 22.7986 13.34 21.7386 15C19.2986 18.82 15.7486 21.02 11.9986 21.02Z"
                      fill="#464646"
                    />
                    <path
                      d="M12.6915 16.2699C12.3415 16.2699 12.0215 16.0199 11.9515 15.6599C11.8715 15.2499 12.1415 14.8599 12.5515 14.7899C13.6515 14.5899 14.5715 13.6699 14.7715 12.5699C14.8515 12.1599 15.2415 11.8999 15.6515 11.9699C16.0615 12.0499 16.3315 12.4399 16.2515 12.8499C15.9315 14.5799 14.5515 15.9499 12.8315 16.2699C12.7815 16.2599 12.7415 16.2699 12.6915 16.2699Z"
                      fill="#464646"
                    />
                    <path
                      d="M2.00141 22.7502C1.81141 22.7502 1.62141 22.6802 1.47141 22.5302C1.18141 22.2402 1.18141 21.7602 1.47141 21.4702L8.94141 14.0002C9.23141 13.7102 9.71141 13.7102 10.0014 14.0002C10.2914 14.2902 10.2914 14.7702 10.0014 15.0602L2.53141 22.5302C2.38141 22.6802 2.19141 22.7502 2.00141 22.7502Z"
                      fill="#464646"
                    />
                    <path
                      d="M14.5287 10.2199C14.3387 10.2199 14.1488 10.1499 13.9988 9.99994C13.7088 9.70994 13.7088 9.22994 13.9988 8.93994L21.4687 1.46994C21.7587 1.17994 22.2388 1.17994 22.5288 1.46994C22.8188 1.75994 22.8188 2.23994 22.5288 2.52994L15.0588 9.99994C14.9088 10.1499 14.7187 10.2199 14.5287 10.2199Z"
                      fill="#464646"
                    />
                  </svg>
                )}
              </span>
            </div>
          </div>
          <div className="Diff">
            {[2, 4, 6, 8].map((len) => (
              <svg
                key={len}
                width="159"
                height="6"
                viewBox="0 0 159 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="159"
                  height="6"
                  rx="3"
                  fill={confirmPassword.length >= len ? checkStrength(confirmPassword) : "#DBDBDB"}
                />
              </svg>
            ))}
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="Buttons">
        <button onClick={() => navigate(-1)} className="Cancel">
          {t('password.buttons.cancel')}
        </button>
        <button onClick={Save} style={isValid() ? {} : { background: "#888888" }} className="Save">
          {t('password.buttons.save')}
        </button>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Password;
